import React__default from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { FixDialog } from '../FixDialog/FixDialog.esm.js';

const useStyles = makeStyles(
  (_theme) => createStyles({
    root: {
      overflow: "auto"
    },
    list: {
      width: "100%"
    }
  })
);
const ErrorList = ({ podAndErrors }) => {
  const classes = useStyles();
  return /* @__PURE__ */ React__default.createElement(Paper, { className: classes.root }, /* @__PURE__ */ React__default.createElement(List, { className: classes.list }, podAndErrors.filter((pae) => pae.errors.length > 0).flatMap((onlyPodWithErrors) => {
    return onlyPodWithErrors.errors.map((error, i) => {
      return /* @__PURE__ */ React__default.createElement(
        React__default.Fragment,
        {
          key: `${onlyPodWithErrors.pod.metadata?.name ?? "unknown"}-eli-${i}`
        },
        i > 0 && /* @__PURE__ */ React__default.createElement(Divider, { key: `error-divider${i}` }),
        /* @__PURE__ */ React__default.createElement(ListItem, null, /* @__PURE__ */ React__default.createElement(Grid, { container: true }, /* @__PURE__ */ React__default.createElement(Grid, { item: true, xs: 9 }, /* @__PURE__ */ React__default.createElement(
          ListItemText,
          {
            primary: error.message,
            secondary: onlyPodWithErrors.pod.metadata?.name
          }
        )), /* @__PURE__ */ React__default.createElement(Grid, { item: true, xs: 3 }, /* @__PURE__ */ React__default.createElement(
          FixDialog,
          {
            pod: onlyPodWithErrors.pod,
            error,
            clusterName: onlyPodWithErrors.cluster.name
          }
        ))))
      );
    });
  })));
};

export { ErrorList };
//# sourceMappingURL=ErrorList.esm.js.map
